import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid2";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import _ from "lodash";
import moment from "moment";
import React from "react";
export default function ManningsLandingResponseDialog(props) {
  const {
    onCancel,
    open,
    onSubmit,
    submitMessage,
    cancelMessage,
    availableShop,
    allShopList,
    submitButtonColor = "primary",
    responseData,
    setResponseData,
  } = props;
  const [availableDates, setAvailableDates] = React.useState([]);
  const [availableTimeSlotOptions, setAvailableTimeSlotOptions] =
    React.useState([]);
  const calAvailableDates = (location_id) => {
    const filteredShop = _.filter(
      allShopList,
      (a) => a.location_id === parseInt(location_id)
    );
    const timeSlot = {};
    _.forEach(filteredShop, (shop) => {
      const formatedDate = moment(shop.date).format("YYYY-MM-DD");
      if (!timeSlot[formatedDate]) {
        timeSlot[formatedDate] = {};
      }
      if (!timeSlot[formatedDate][shop.user_id]) {
        timeSlot[formatedDate][shop.user_id] = {
          start_time: shop.start_time ?? "11:00",
          end_time: shop.end_time ?? "19:00",
          user_id: shop.user_id,
          user_alias: shop.alias,
          user_staff_code: shop.staff_code,
        };
      }
      if (!timeSlot[formatedDate][shop.user_id][shop.pick_up_start_time]) {
        timeSlot[formatedDate][shop.user_id][shop.pick_up_start_time] = 1;
      } else {
        timeSlot[formatedDate][shop.user_id][shop.pick_up_start_time]++;
      }
    });

    setAvailableDates(timeSlot);
  };
  const calAvailableTimeSlotOptions = (date) => {
    const formatedDate = moment(date).format("YYYY-MM-DD");
    const selectedDate = _.orderBy(availableDates[formatedDate], "start_time");
    const timeSlotOption = [];

    _.forEach(selectedDate, (d) => {
      const { start_time, end_time } = d;
      let start = moment(`${start_time}:00`, "HH:mm:ss");
      let end = moment(`${end_time}:00`, "HH:mm:ss");
      while (start.isBefore(end)) {
        const timeslot = `${moment(start).format("hh:mmA")} - ${moment(start)
          .add(1, "hour")
          .format("hh:mmA")} (${d.user_staff_code} - ${d.user_alias}) ${
          d[`${start.format("HH:mm:ss")}`] ?? 0
        } 個預約`;
        if (!timeSlotOption.find((o) => o.option === timeslot)) {
          timeSlotOption.push({
            option: `${timeslot}`,
            user_id: d.user_id,
            value: moment(start).format("HH:mm:ss"),
          });
        }
        start.add(1, "hour");
      }
    });

    setAvailableTimeSlotOptions(timeSlotOption);
  };
  const handleShopChange = (event, newValue) => {
    setResponseData((prev) => {
      return {
        ...prev,
        pick_up_location_id: newValue ? parseInt(newValue.value) : null,
        pick_up_date: null,
        pick_up_start_time: null,
      };
    });
    calAvailableDates(newValue.value);
  };
  const handleDateChange = (event) => {
    setResponseData((prev) => {
      return {
        ...prev,
        pick_up_date: event.target.value,
        pick_up_start_time: null,
      };
    });
    calAvailableTimeSlotOptions(event.target.value);
  };
  const handleTimeSlotChange = (event) => {
    const staffId = availableTimeSlotOptions.find(
      (o) => o.value === event.target.value
    ).user_id;
    setResponseData((prev) => {
      return {
        ...prev,
        pick_up_start_time: event.target.value,
        contact_promoter: staffId,
      };
    });
  };

  React.useEffect(() => {
    calAvailableDates(responseData.pick_up_location_id);
  }, []);
  React.useEffect(() => {
    calAvailableTimeSlotOptions(
      moment(responseData.pick_up_date).format("YYYY-MM-DD")
    );
  }, [availableDates]);
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle>更改預約</DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <DialogContentText>
          <Box sx={{ m: 1 }}>
            <Grid container spacing={1}>
              <Grid size={6}>
                <FormControl fullWidth sx={{ m: 1 }}>
                  <Autocomplete
                    required
                    id="combo-box-demo"
                    options={availableShop}
                    value={availableShop.find(
                      (option) =>
                        parseInt(option.value) ===
                        responseData?.pick_up_location_id
                    )}
                    label="店鋪"
                    onChange={handleShopChange}
                    renderInput={(params) => (
                      <TextField {...params} label="店鋪" />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid size={6}>
                <FormControl fullWidth sx={{ m: 1 }}>
                  <InputLabel id="select-date-label">日期</InputLabel>
                  <Select
                    labelId="select-date-label"
                    id="select-date"
                    label="日期"
                    onChange={handleDateChange}
                    value={moment(responseData?.pick_up_date).format(
                      "YYYY-MM-DD"
                    )}
                  >
                    {_.map(availableDates, (availableTimeSlot, key) => (
                      <MenuItem key={key} value={key}>
                        {key}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={12}>
                <FormControl fullWidth sx={{ m: 1 }}>
                  <InputLabel id="select-timeslot-label">時間</InputLabel>
                  <Select
                    labelId="select-timeslot-label"
                    id="select-timeslot"
                    label="時間"
                    onChange={handleTimeSlotChange}
                    value={responseData.pick_up_start_time}
                  >
                    {_.map(
                      availableTimeSlotOptions,
                      (availableTimeSlotOption) => (
                        <MenuItem
                          key={availableTimeSlotOption.option}
                          value={availableTimeSlotOption.value}
                        >
                          {availableTimeSlotOption.option}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{cancelMessage}</Button>
        <Button
          onClick={onSubmit}
          disabled={!responseData.pick_up_start_time}
          color={submitButtonColor}
          type="submit"
        >
          {submitMessage}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
